module.exports = __webpack_public_path__ + "img/title1.7ec9e0c6.png";